/**
 * Returns the title for a subject
 * @param {string} subject
 * @param {boolean} activeELALicense
 * @returns {string} title
 */

const getActivitySubjectName = (subject, activeELALicense) => {
  switch (subject) {
    case "ELA":
      return activeELALicense
        ? "English Language Arts"
        : "Reading Comprehension";
    case "SOCIAL_STUDIES":
      return "Social Studies";
    default:
      return subject;
  }
};

export default getActivitySubjectName;
